import { Component } from 'react'
import { connect } from 'react-redux'
import { setActiveCage } from 'reducers/slaMonitor/reducer'

const CHANGE_SITE = 'CHANGE_SITE'
const CHANGE_DATE = 'CHANGE_DATE'

class ActiveCageLoader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      changeStatus: null,
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.activeSite !== nextProps.activeSite) {
      this.setState({ changeStatus: CHANGE_SITE })

      return false
    }

    if (
      this.props.activeDate !== nextProps.activeDate ||
      (this.props.isReloadCageList !== nextProps.isReloadCageList &&
        nextProps.isReloadCageList)
    ) {
      this.setState({ changeStatus: CHANGE_DATE })

      return false
    }

    if (this.props.cageList !== nextProps.cageList) {
      if (this.state.changeStatus === CHANGE_DATE) {
        return false
      }

      let activeCage = 0

      if (nextProps.cageList.size !== 0) {
        const firstCage = nextProps.cageList.toArray()[0]
        activeCage = firstCage.id
      }

      this.setState({ changeStatus: null }, () => {
        this.props.setActiveCage(activeCage)
      })

      return false
    }

    return true
  }

  render() {
    return null
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    isReloadCageList: state.getIn(['slaMonitor', 'isReloadCageList']),
    cageList: state.getIn(['slaMonitor', 'cageList']),
  }),
  {
    setActiveCage,
  },
)(ActiveCageLoader)
